export interface ViewHeaderProps {
  title: string;
  lede?: string;
}

/** The page title and optional lede shared by every view. Used to also carry
 *  a "Step N" eyebrow and prev/next arrows (`StepHeader`) — removed after
 *  tester feedback that framing seven independently-editable screens as a
 *  linear wizard was misleading. */
export function ViewHeader({ title, lede }: ViewHeaderProps) {
  return (
    <header className="flex flex-col gap-1">
      <h2 className="text-2xl font-bold tracking-tight text-foreground">{title}</h2>
      {lede !== undefined ? <p className="max-w-prose text-sm text-muted-foreground">{lede}</p> : null}
    </header>
  );
}
